import { SessionKvKey } from "../../api/features/session-kv";
import { useMemo } from "react";
import useSessionSetValue from "./useSessionSetValue";
import useSessionGetValue from "./useSessionGetValue";

export default function useSessionValue<T>(key: SessionKvKey) {
  const value = useSessionGetValue<T>(key);
  const setValue = useSessionSetValue<T>(key);

  return useMemo(
    () => ({
      value,
      setValue,
    }),
    [value, setValue]
  );
}
